import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Material
import { Avatar, Box, Menu, MenuItem, Paper, Typography } from '@mui/material';

import { Stack } from '@mui/system';
import { connect, useDispatch } from 'react-redux';
import {
  setIsOpenAuthModal,
  setIsOpenComplainModal,
  setIsOpenResendingModal
} from '../redux/mainReducer';
import DefaultAvatar from '../assets/defaultPostImg.jpg';
import { base } from '../redux/thunk';
import ApiService from '../helpers/apiHelper';
import '../pages/MainPage/index.css';
import { MoreHoriz } from '@mui/icons-material';
import { useSnackbar } from 'notistack';

function UserCard({
  index,
  el,
  noWidth = false,
  userData,
  language,
  subscriptions,
  blockedUsers,
  usersWhoBlocked,
  getUserSubscriptionsThunk
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const apiSubscribe = new ApiService('auth/subscribe');
  const apiUnSubscribe = new ApiService('auth/unsubscribe');
  const apiComplaint = new ApiService('auth/user/complaint-user');
  const dispatch = useDispatch();
  // eslint-disable-next-line
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const sendComplaint = (type, text) => {
    apiComplaint
      .updateDataID(el?.id, {
        complaintType: type,
        complaintDescription: text.length !== 0 ? text : null
      })
      .then((res) => {
        dispatch(setIsOpenComplainModal({ isOpen: false, func: null }));
        enqueueSnackbar('Скаргу надіслано.', { variant: 'success' });
      })
      .catch((error) => {
        console.error(error);
        enqueueSnackbar('Сталась помилка.', { variant: 'error' });
      });
  };
  return (
    <Paper
      key={index}
      // className="userCard"
      sx={
        el && el?.roleType !== 'PREMIUM_USER'
          ? {
              width: !noWidth ? '400px' : 'unset',
              height: { xs: '82px', sm: '250px' },
              margin: '0px 0.5%',
              textAlign: 'center',
              backgroundColor: 'white',
              borderRadius: '8px',
              padding: { xs: '8px', sm: '16px' },
              border: !blockedUsers.find((user) => user.id === el?.id)
                ? '2px solid #F5F4F4'
                : '2px solid #FFE5E5',
              boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
              position: 'relative'
            }
          : {
              width: !noWidth ? '400px' : 'unset',
              height: { xs: '82px', sm: '250px' },
              margin: '0px 0.5%',
              textAlign: 'center',
              backgroundColor: 'white',
              borderRadius: '8px',
              padding: { xs: '8px', sm: '16px' },
              border: !blockedUsers.find((user) => user.id === el?.id)
                ? '2px solid #E2F2FF'
                : '2px solid #FFE5E5',
              position: 'relative',
              boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
            }
      }
    >
      {window.location.href.includes('search') && el?.promotedBySearch && (
        <Box
          sx={{
            display: { xs: 'none', sm: 'block' },
            position: 'absolute',
            width: 'fit-content',
            backgroundColor: '#E2F2FF',
            padding: '4px 8px',
            borderRadius: '4px',
            boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
            fontFamily: 'FixelText-Medium',
            fontWeight: '500',
            color: '#60A5DF',
            fontSize: '16px',
            left: '8px',
            top: '8px'
            // top: '4px',
            // left: '4px'
          }}
        >
          Топчик
        </Box>
      )}
      <Stack
        spacing={0}
        direction="column"
        justifyContent="start"
        style={{ padding: '0', height: '100%' }}
      >
        <Stack direction={{ xs: 'row', sm: 'column' }} spacing={2} style={{ alignItems: 'center' }}>
          <Avatar
            onClick={() => {
              if (userData?.id) {
                // navigate(`/${language}/service/${el.id}`);*/}
                window.open(`${window.location.origin}/${language}/user-page/${el?.id}`);
                window.scrollTo({ top: 0 });
              } else {
                dispatch(setIsOpenAuthModal(true));
              }
            }}
            src={el?.photoUrl ? `${el?.photoUrl}` : DefaultAvatar}
            alt={el.nikname}
            // sx={{ width: '66px', height: '66px', display: 'block', borderRadius: '70px' }}
            sx={
              el && el?.roleType === 'PREMIUM_USER'
                ? {
                    border: !blockedUsers.find((user) => user.id === el?.id)
                      ? '2px solid #E2F2FF'
                      : '2px solid #FFE5E5',
                    boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',

                    borderRadius: '70px',
                    width: { xs: 60, sm: 70 },
                    height: { xs: 60, sm: 70 },
                    cursor: 'pointer'
                  }
                : {
                    border: !blockedUsers.find((user) => user.id === el?.id)
                      ? '2px solid #F5F4F4'
                      : '2px solid #FFE5E5',
                    boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                    width: { xs: 60, sm: 70 },
                    height: { xs: 60, sm: 70 },
                    borderRadius: '70px',
                    cursor: 'pointer'
                  }
            }
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: { xs: 'start', sm: 'center' },
              justifyContent: { xs: 'start', sm: 'center' }
            }}
          >
            <Typography
              onClick={() => {
                if (userData?.id) {
                  // navigate(`/${language}/service/${el.id}`);*/}
                  window.open(`${window.location.origin}/${language}/user-page/${el?.id}`);
                  window.scrollTo({ top: 0 });
                } else {
                  dispatch(setIsOpenAuthModal(true));
                }
              }}
              sx={{
                fontSize: { xs: '12px', sm: '14px', lg: '16px' },
                textAlign: 'left',
                wordBreak: 'break-all',
                maxWidth: '100%',
                color: '#7C7C7C',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              {`@${el.nickname}`}
              {el && el?.promotedBySearch && window.location.href.includes('search') && (
                <Box
                  sx={{
                    display: { xs: 'block', sm: 'none' },
                    // position: 'absolute',
                    width: 'fit-content',
                    backgroundColor: '#E2F2FF',
                    padding: '0px 4px',
                    borderRadius: '4px',
                    boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                    fontFamily: 'FixelText-Medium',
                    fontWeight: '500',
                    color: '#60A5DF',
                    fontSize: '12px',
                    ml: '8px'
                    // right: '8px',
                    // top: '8px'
                  }}
                >
                  Топчик
                </Box>
              )}
              {el && !el?.promotedBySearch && el?.roleType === 'PREMIUM_USER' && (
                <Box
                  sx={{
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: { xs: 'block', sm: 'none' }
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'FixelText-SemiBold',
                      fontSize: '12px',
                      p: '0px 4px',
                      backgroundColor: '#60A5DF',
                      borderRadius: '5px',
                      color: 'white',
                      ml: '8px'
                    }}
                  >
                    Преміум
                  </Typography>
                </Box>
              )}
            </Typography>
            <Stack
              onClick={() => {
                if (userData?.id) {
                  // navigate(`/${language}/service/${el.id}`);*/}
                  window.open(`${window.location.origin}/${language}/user-page/${el?.id}`);
                  window.scrollTo({ top: 0 });
                } else {
                  dispatch(setIsOpenAuthModal(true));
                }
              }}
              sx={{
                width: '100%',
                overflow: 'hidden',
                gap: { xs: '5px', sm: '8px' },
                flexWrap: 'wrap',
                alignItems: { xs: 'start', sm: 'center' },
                justifyContent: { xs: 'start', sm: 'center' },
                mt: '0px !important',
                maxWidth: { xs: '231px', sm: 'unset' },
                cursor: 'pointer'
              }}
              direction="row"
            >
              {el?.surname && (
                <Typography
                  sx={{
                    fontSize: { xs: '14px', sm: '16px', lg: '20px' },
                    lineHeight: { xs: '14px', sm: '16px', lg: '20px' },
                    textAlign: { xs: 'left', sm: 'center' },
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    fontFamily: 'FixelText-Medium',
                    fontWeight: '500',
                    width: '100%',
                    cursor: 'pointer'
                  }}
                >
                  {el.surname}
                </Typography>
              )}
              {el?.name && (
                <Typography
                  sx={{
                    fontSize: { xs: '14px', sm: '16px', lg: '20px' },
                    lineHeight: { xs: '14px', sm: '16px', lg: '20px' },
                    textAlign: { xs: 'left', sm: 'center' },
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    fontFamily: 'FixelText-Medium',
                    fontWeight: '500',
                    width: '100%',
                    cursor: 'pointer'
                  }}
                >
                  {el.name}
                </Typography>
              )}

              {/*{el?.number && el?.number.length !== 0 && el?.number.length !== 4 && (*/}
              {/*  <div style={{ display: 'flex' }}>*/}
              {/*    <Typography*/}
              {/*      sx={{ paddingLeft: '25px', mt: '14px', position: 'relative' }}*/}
              {/*      fontSize={16}*/}
              {/*      lineHeight="20px"*/}
              {/*      fontWeight={400}*/}
              {/*    >*/}
              {/*      <PhoneAndroidIcon*/}
              {/*        style={{*/}
              {/*          position: 'absolute',*/}
              {/*          left: '-1px',*/}
              {/*          color: '#60A5DF',*/}
              {/*          fontSize: '22px'*/}
              {/*        }}*/}
              {/*      />*/}
              {/*      {`${el.number}`}*/}
              {/*    </Typography>{' '}*/}
              {/*  </div>*/}
              {/*)}*/}

              {/*{el?.city &&*/}
              {/*  el?.city.length !== 0 &&*/}
              {/*  el?.country &&*/}
              {/*  el?.country.length !== 0 &&*/}
              {/*  el?.region &&*/}
              {/*  el?.region.length !== 0 && (*/}
              {/*    <div style={{ display: 'flex' }}>*/}
              {/*      <Typography*/}
              {/*        sx={{*/}
              {/*          paddingLeft: '25px',*/}
              {/*          mt: '14px',*/}
              {/*          position: 'relative',*/}
              {/*          textAlign: 'left'*/}
              {/*        }}*/}
              {/*        fontSize={16}*/}
              {/*        lineHeight="20px"*/}
              {/*        fontWeight={400}*/}
              {/*      >*/}
              {/*        <PushPinOutlinedIcon*/}
              {/*          style={{*/}
              {/*            position: 'absolute',*/}
              {/*            left: '-1px',*/}
              {/*            color: '#60A5DF',*/}
              {/*            fontSize: '22px',*/}
              {/*            transform: 'rotate(-45deg)'*/}
              {/*          }}*/}
              {/*        />*/}
              {/*        {`${el?.city ? el.city : ''}${*/}
              {/*          el?.city && el?.city.length !== 0 && el?.region && el?.region.length !== 0*/}
              {/*            ? ', '*/}
              {/*            : ''*/}
              {/*        }${el?.region ? `${el.region} обл.` : ''}${*/}
              {/*          el?.city && el?.city.length !== 0 && el?.country && el?.country.length !== 0*/}
              {/*            ? ', '*/}
              {/*            : ''*/}
              {/*        }${el?.country ? el.country : ''}`}*/}
              {/*      </Typography>*/}
              {/*    </div>*/}
              {/*  )}*/}
            </Stack>
          </Box>
        </Stack>

        {el && el?.roleType === 'PREMIUM_USER' && (
          <Box
            sx={{
              display: { xs: 'none', sm: 'flex' },
              justifyContent: 'center',
              alignItems: 'center',

              m: '8px auto 0px'
            }}
          >
            <Typography
              sx={{
                fontFamily: 'FixelText-SemiBold',
                fontSize: '12px',
                p: '3px 6px',
                backgroundColor: '#60A5DF',
                borderRadius: '5px',
                color: 'white'
              }}
            >
              Преміум
            </Typography>
          </Box>
        )}

        {/*<Stack*/}
        {/*  direction="row"*/}
        {/*  justifyContent={*/}
        {/*    userData.id !== el.id &&*/}
        {/*    !blockedUsers.find((user) => user.id === el?.id) &&*/}
        {/*    !usersWhoBlocked.find((user) => user === el?.id)*/}
        {/*      ? 'space-between'*/}
        {/*      : 'end'*/}
        {/*  }*/}
        {/*  sx={{ borderTop: '2px solid #F0F0F0', paddingTop: '15px' }}*/}
        {/*  alignItems="center"*/}
        {/*>*/}
        {/*  {userData.id !== el.id &&*/}
        {/*    !blockedUsers.find((user) => user.id === el?.id) &&*/}
        {/*    !usersWhoBlocked.find((user) => user === el?.id) && (*/}
        {/*      <ContactsBtn*/}
        {/*        width="max-content"*/}
        {/*        isInContacts={subscriptions.find((subscription) => subscription.id === el.id)}*/}
        {/*        isFetching={isFetching}*/}
        {/*        onClick={() => {*/}
        {/*          setIsFetching(true);*/}
        {/*          if (userData?.id) {*/}
        {/*            if (subscriptions.find((subscription) => subscription.id === el.id)) {*/}
        {/*              apiUnSubscribe.deleteItemQuery({ subscriptionId: el.id }).then((res) => {*/}
        {/*                setIsFetching(false);*/}
        {/*                // getUserSubscriptionsThunk(userData.id);*/}
        {/*              });*/}
        {/*            } else {*/}
        {/*              apiSubscribe.updateDataQuery({ subscriptionId: el.id }).then((res) => {*/}
        {/*                setIsFetching(false);*/}
        {/*                // getUserSubscriptionsThunk(userData.id);*/}
        {/*              });*/}
        {/*            }*/}
        {/*          } else {*/}
        {/*            dispatch(setIsOpenAuthModal(true));*/}
        {/*          }*/}
        {/*        }}*/}
        {/*      />*/}
        {/*    )}*/}

        {/*  /!* eslint-disable-next-line *!/*/}
        {/*  <p*/}
        {/*    href="#"*/}
        {/*    onClick={(event) => {*/}
        {/*      event.stopPropagation();*/}
        {/*      if (userData?.id) {*/}
        {/*        navigate(`/${language}/user-page/${el.id}?type=posts`);*/}
        {/*      } else {*/}
        {/*        dispatch(setIsOpenAuthModal(true));*/}
        {/*      }*/}
        {/*    }}*/}
        {/*    style={{*/}
        {/*      fontSize: '14px',*/}
        {/*      textAlign: 'left',*/}
        {/*      textDecoration: 'underline',*/}
        {/*      color: 'black',*/}
        {/*      cursor: 'pointer',*/}

        {/*    }}*/}
        {/*  >*/}
        {/*    Переглянути профіль*/}
        {/*  </p>*/}
        {/*</Stack>*/}
      </Stack>
      {userData?.id && !window.location.href.includes('messages') && (
        <Box
          id="positioned-button"
          onClick={(event) => handleClick(event)}
          sx={{
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: { xs: '30px', sm: '40px' },
            height: { xs: '30px', sm: '40px' },
            backgroundColor: 'white',
            cursor: 'pointer',
            boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
            borderRadius: '50px',
            right: { xs: '8px', sm: '16px' },
            top: { xs: 'calc(50% - 30px/2)', sm: '16px' },
            zIndex: 102
          }}
        >
          <MoreHoriz sx={{ cursor: 'pointer' }} />
        </Box>
      )}
      <Menu
        anchorEl={anchorEl}
        id="action-menu"
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'hidden',
            boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
            borderRadius: '4px',
            border: 'none',
            paddingTop: '10px',
            paddingLeft: '20px',
            paddingRight: '20px',
            width: '283px',
            mt: 1
          }
        }}
        autoFocus={false}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem
          sx={{
            borderRadius: '4px',
            '&.MuiMenuItem-root:hover': { backgroundColor: '#E2F2FF' },
            fontFamily: 'FixelText-Medium',
            fontWeight: '500',
            pl: '12px !important',
            m: '2px 0px !important'
          }}
          onClick={() => {
            handleClose();
            if (userData?.id) {
              if (!el?.isBlocked) {
                window.open(`${window.location.origin}/${language}/user-page/${el.id}`);
              }
            } else {
              dispatch(setIsOpenAuthModal(true));
            }
          }}
        >
          Переглянути профіль
        </MenuItem>

        <MenuItem
          sx={{
            borderRadius: '4px',
            ':hover': { backgroundColor: '#E2F2FF' },
            fontFamily: 'FixelText-Medium',
            fontWeight: '500',
            pl: '12px !important',
            m: '2px 0px !important'
          }}
          onClick={() => {
            handleClose();
            dispatch(setIsOpenResendingModal({ isOpen: true, id: el.id, type: 'user' }));
          }}
        >
          Відправити у повідомлення
        </MenuItem>
        {el?.id !== userData?.id && (
          <MenuItem
            sx={{
              borderRadius: '4px',
              ':hover': { backgroundColor: '#E2F2FF' },
              fontFamily: 'FixelText-Medium',
              fontWeight: '500',
              pl: '12px !important',
              m: '2px 0px !important'
            }}
            onClick={() => {
              if (userData?.id) {
                if (subscriptions.find((subscription) => subscription.id === el.id)) {
                  apiUnSubscribe.deleteItemQuery({ subscriptionId: el.id }).then((res) => {
                    getUserSubscriptionsThunk(userData.id);
                  });
                } else {
                  apiSubscribe.updateDataQuery({ subscriptionId: el.id }).then((res) => {
                    getUserSubscriptionsThunk(userData.id);
                  });
                }
              } else {
                dispatch(setIsOpenAuthModal(true));
              }
            }}
          >
            {subscriptions.find((subscription) => subscription.id === el.id)
              ? 'Видалити із контактів'
              : '   Додати у контакти'}
          </MenuItem>
        )}

        {userData?.id && el?.id !== userData?.id && (
          <MenuItem
            sx={{
              borderRadius: '4px',
              ':hover': { backgroundColor: '#FFE5E5' },

              fontFamily: 'FixelText-Medium',
              fontWeight: '500',
              color: '#F64D36',

              pl: '12px !important',
              m: '2px 0px !important'
            }}
            onClick={() => {
              dispatch(setIsOpenComplainModal({ isOpen: true, func: sendComplaint }));
              handleClose();
            }}
          >
            <Typography component="p" fontSize={16} sx={{ lineHeight: '18px' }} fontWeight={400}>
              Поскаржитись
            </Typography>
          </MenuItem>
        )}
      </Menu>
    </Paper>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData,
    subscriptions: state.global.userSubscriptions,
    blockedUsers: state.global.blockedUsers,
    usersWhoBlocked: state.global.usersWhoBlocked
  };
};
export default connect(mapStateToProps, {
  getUserSubscriptionsThunk: base.getUserSubscriptionsThunk
})(UserCard);
